import React from "react";
import Loadable from "../../react-loadable";
import "./index.less";
import middleware from "../../middleware";
const CodeMirror = Loadable({
  loader: () => import("./Codemirror"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});

class WeaCodeMirror extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value || "",
      theme: props.theme || "eclipse",
      mode: props.mode || "javascript"
    };
  }

  componentWillReceiveProps(nextProps) {
    // codeMirror内部受控问题：这里手动改值
    if (nextProps.value && nextProps.value !== this.state.value) {
      this.onChange(nextProps.value);
      this.setValue(nextProps.value);
    }
    if (nextProps.theme && nextProps.theme !== this.state.theme) {
      this.setState({ theme: nextProps.theme });
      this.setOption("theme", nextProps.theme);
    }
    if (nextProps.mode && nextProps.mode !== this.state.mode) {
      this.setState({ mode: nextProps.mode });
      this.setOption("mode", nextProps.mode);
    }
  }

  setValue = value => {
    if (this.codeMirror && this.codeMirror.codeMirror) {
      this.codeMirror.codeMirror.setValue(value);
    }
  };

  setOption = (name, value) => {
    if (this.codeMirror && this.codeMirror.codeMirror) {
      this.codeMirror.codeMirror.setOption([name], value);
    }
  };

  onChange = value => {
    this.setState({ value });
    this.props.onChange(value);
  };

  render() {
    const {
      width = "100%",
      height = "100%",
      viewAttr = 2,
      className = "",
      style = {}
    } = this.props;
    const { value, theme, mode } = this.state;
    const options = {
      mode: mode, //定义mode
      theme: theme, //选中的theme
      styleActiveLine: true,
      autofocus: true,
      lineNumbers: true, //显示行号s
      lineWrapping: false, // 长文本横向滚动
      extraKeys: { Ctrl: "autocomplete" }, //自动提示配置
      tabSize: 2, // tab字符的宽度
      readOnly: viewAttr === 1, // 是否只读
      ...this.props.options
    };

    return (
      <div
        style={{ width: width, height: height, ...style }}
        className={`wea-code-mirror ${className}`}
      >
        <CodeMirror
          {...this.props}
          value={value}
          ref={ref => (this.codeMirror = ref)}
          options={options}
          onChange={code => this.onChange(code)}
        />
      </div>
    );
  }
}

const Com = middleware(WeaCodeMirror, "WeaCodeMirror");
export default Com;



// WEBPACK FOOTER //
// ./ecology9/wea-code-mirror/index.js